<!--成品分单->分单结果->产能负荷-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          ref="productBroadCategoryRef"
          slot="productBroadCategorys"
          :value.sync="queryParams.productBroadCategorys"
          selectType="selectMultipleSearch"
          requestApi="/scp/supplierRankCategory/findCategoryComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{}"
          searchParam="category"
        />
        <global-select
          ref="supplierNameRef"
          slot="supplierCodes"
          :value.sync="queryParams.supplierCodes"
          selectType="selectMultipleSearch"
          requestApi="/scp/supplierRankCategory/findSupplierComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{}"
          searchParam="supplierName"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiExportInvFdCapacityInspectionReport" ref="download" />
        <a-button type="primary" :loading="btnLoading" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="capacityLoadTableRef"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!--动态月-->
          <template v-for="item in cnAmountList" :slot="item" slot-scope="{ text, record }">
            <span :key="'cnAmountList-'+item" v-if="!isEdit || currentId !== record.id">{{ record[item] }}</span>
            <a-input-number
              :key="'cnAmountList-input-'+item"
              v-else
              style="width: 100%"
              v-model="record[item]"
              :min="0"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </template>
          <span class="operation-btn" slot="operation" slot-scope="text">
            <a-button  type="link" v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a-button>
            <a-button type="link" v-if="isEdit && currentId === text.record.id" :loading="btnLoading" @click="handleSave(text.record)">保存</a-button>
            <a-button type="link" v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a-button>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'
import {
  apiGetInvFdCapacityInspectionReportHeader,
  apiGetInvFdCapacityInspectionReportList,
  apiExportInvFdCapacityInspectionReport, apiScpUpdateSupplierCapacity
} from '@/api/finished-goods-order'

export default {
  name: 'CapacityLoad',
  components: { DownloadModal },
  mixins: [cacheSearch],
  data () {
    return {
      btnLoading: false,
      dateHeader: [],
      apiExportInvFdCapacityInspectionReport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInvFdCapacityInspectionReportList, true),
        pageCurrent: true
      },
      cnAmountList: ['cnAmount1', 'cnAmount2', 'cnAmount3', 'cnAmount4'], // 产能
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        supplierCodes: undefined,
        productBroadCategorys: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '供应商', decorator: ['supplierCodes'], type: 'supplierCodes' },
        { label: '工艺大类', decorator: ['productBroadCategorys'], type: 'productBroadCategorys' }
      ],
      // 表格字段
      columns: [
        { title: '供应商编码', dataIndex: 'supplierCode', align: 'center', width: 110, stickyFixed: 'left' },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 100, stickyFixed: 'left' },
        { title: '工艺大类', dataIndex: 'productBroadCategoryName', align: 'center', width: 120, stickyFixed: 'left' },
        { title: '已报检(万元)', children: [] },
        { title: '在途(万元)', children: [] },
        { title: '预分配(万元)', children: [] },
        { title: '产能(万元)', children: [] },
        { title: '产能负荷(%)', children: [] },
        {
          title: '操作',
          width: 95,
          dataIndex: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache('refSearchForm')
    }
    this.getHeader()
  },
  mounted () {
    this.btnLoading = false
    this.onSearch()
  },
  methods: {
    // 获取表头数据
    getHeader() {
      this.dateHeader = []
      apiGetInvFdCapacityInspectionReportHeader({}).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.dateHeader = res.data
          res.data.forEach(item => {
            if(Object.keys(item)[0]) {
              const dateKey = Object.keys(item)[0]
              if(dateKey.includes('ybjAmount')) { // 已报检
                this.columns[3].children.push({ title: item[dateKey], width: 80, dataIndex: dateKey, align: 'center' })
              }else if(dateKey.includes('ztAmount')) { // 在途
                this.columns[4].children.push({ title: item[dateKey], width: 80, dataIndex: dateKey, align: 'center' })
              }else if(dateKey.includes('yfpAmount')) { // 预分配
                this.columns[5].children.push({ title: item[dateKey], width: 80, dataIndex: dateKey, align: 'center' })
              }else if(dateKey.includes('cnAmount')) { // 产能
                this.columns[6].children.push({
                  title: item[dateKey],
                  width: 80,
                  dataIndex: dateKey,
                  align: 'center',
                  scopedSlots: { customRender: dateKey }
                })
              }else if(dateKey.includes('cnLoad')) { // 产能负荷
                this.columns[7].children.push({ title: item[dateKey], width: 80, dataIndex: dateKey, align: 'center' })
              }
            }
          })
        }
      })
    },
    // 保存
    handleSave(record) {
      const params = []
      this.cnAmountList.forEach(item => {
        const getMonth = this.dateHeader.find(val => val[item])
        params.push({
          supplierCode: record.supplierCode,
          productBroadCategory: record.productBroadCategory,
          month: getMonth[item],
          cnAmount: record[item]
        })
      })
      this.btnLoading = true;
      apiScpUpdateSupplierCapacity(params).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.currentId = ''
          this.isEdit = false;
          this.onSearch({}, true)
        } else {
          this.$message.error(res?.msg || '保存失败')
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 取消
    handleCancel() {
      this.isEdit = false;
      this.onSearch({}, true)
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 表单搜索
    onSearch (value = {}, isNotGoFirstPage = false) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.capacityLoadTableRef.searchParams = params;
      this.$refs.capacityLoadTableRef.getData(isNotGoFirstPage);
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        supplierCodes: undefined,
        productBroadCategorys: undefined
      }
      this.$refs.supplierNameRef.handleSearch(''); // 重新查询供应商名称下拉
      this.$refs.productBroadCategoryRef.handleSearch('');
    },
    // 导出
    handleExport () {
      const params = this.$refs.capacityLoadTableRef.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.operation-btn{
  .ant-btn-link:focus, .ant-btn-link:hover {
    border-color: transparent !important;
  }
  .ant-btn{
    padding: 0 0 !important;
  }
}
</style>
